import { initTheming } from "../core/utils/theming-utils";
const commonRoutine = () => {
    initTheming();
};
export default commonRoutine;
